import { getNavigationBarHeight } from '../../../../design3/asset-build/js/custom/navigation';

window.FS ||= {};
window.FS.ACTIONS ||= {};

const init = () => {
	const setURL = newHash => {
		const newUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${newHash}`;
		window.history.pushState(null, '', newUrl);
	};

	// id of GGV div
	let ggvId = '#' + $('[data-ggv]').attr('id');
	// if group offers use the ggvId to get the div, else use whatever is in the url.
	let hash = window.location.hash == '#group_offers' ? ggvId : window.location.hash;

	let ctas;

	try {
		// $(hash) will throw an error if there's an invalid jquery selector string
		ctas = $(hash).find('.OfferCard-cta-details');
	} catch (e) {
		// just create an empty jQuery object
		ctas = $();
	}

	$('.GroupOfferCard .OfferCard-cta-details').on('click', function () {
		const newHash = '#' + $(this).closest('.OfferCard-container').attr('id');
		const topOfCard = $(newHash).closest('.OffersList-offer');
		const expanded = $(this).hasClass('OfferCard-cta-details--expanded');
		if (newHash) {
			$('html, body').animate(
				{
					scrollTop: topOfCard.offset().top - getNavigationBarHeight(),
				},
				500
			);
		}

		if (expanded) {
			setURL(newHash);
		}
	});

	if (ctas.length) {
		ctas.get(1).click();
	}
};

export default function groupOffer() {
	window.FS.ACTIONS.AFTER_OFFER_CARD_LOADED = {
		arguments: {
			func: init,
		},
	};
	window.dispatchEvent(new Event('fsActionAdded'));
}
